var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var report = "app-report";
export var EReportsURLKeys;
(function (EReportsURLKeys) {
    EReportsURLKeys["DASHBOARD_URL"] = "dashboardUrl";
    EReportsURLKeys["HOLDING_REPORT_URL"] = "holdingReportUrl";
    EReportsURLKeys["DOWNLOAD_REPORT_URL"] = "downloadReportUrl";
    EReportsURLKeys["DOWNLOAD_REPORT_COM_URL"] = "downloadReportCOMUrl";
    EReportsURLKeys["UNDERSTANDING_SECT_URL"] = "understandingSectUrl";
    EReportsURLKeys["PNL_REPORT_URL"] = "pnlReportUrl";
    EReportsURLKeys["POSITION_REPORT_URL"] = "positionReportUrl";
    EReportsURLKeys["TAX_REPORT_URL"] = "taxReportUrl";
    EReportsURLKeys["TAX_YEAR_DROP_DOWN"] = "taxYearDropDown";
    EReportsURLKeys["POSTION_SQUARE_OFF"] = "postionSquareOff";
    EReportsURLKeys["DP_TRANSACTION_HISTORY"] = "dpTransactionHistory";
    EReportsURLKeys["DP_IDS"] = "dpIds";
    EReportsURLKeys["DP_TRANSACTION_SUBMIT"] = "dpTransactionSubmit";
    EReportsURLKeys["DP_URL"] = "dpURL";
    EReportsURLKeys["ROOT_URL"] = "rootUrl";
    EReportsURLKeys["MARGIN"] = "margin";
    EReportsURLKeys["CONTRACT"] = "contract";
    EReportsURLKeys["CONTRACT_NOTE"] = "contractNote";
    EReportsURLKeys["TRANSACTION"] = "transaction";
    EReportsURLKeys["SUBSCRIPTION"] = "subscription";
    EReportsURLKeys["LEDGER"] = "ledger";
    EReportsURLKeys["LEDGER_COMM"] = "ledgerComm";
    EReportsURLKeys["MARKET_MAP_ACC"] = "marketMapAcc";
    EReportsURLKeys["ALERTS_OVERVIEW"] = "alertsOveriew";
    EReportsURLKeys["COMMON_COMMODITY"] = "commonCommodity";
    EReportsURLKeys["FAMILY_TAGGING"] = "familyTagging";
})(EReportsURLKeys || (EReportsURLKeys = {}));
var configURL = {
    dashboardUrl: config.jmw_reports + config.reportBase + "app-report/equity/dashboard",
    holdingReportUrl: config.jmw_reports + config.reportBase + "app-report/equity/holding",
    downloadReportUrl: config.jmw_reports + config.reportBase + "app-report/equity/",
    downloadReportCOMUrl: config.jmw_reports + config.reportBase + "app-report/comm/",
    understandingSectUrl: config.jmw_reports + config.reportBase + "app-report/report/understanding",
    pnlReportUrl: config.jmw_reports + config.reportBase + "app-report/equity/pnl",
    positionReportUrl: config.jmw_reports + config.reportBase + "app-report/equity/position",
    positionCommodityUrl: config.jmw_reports + config.reportBase + "app-report/commodity/position",
    taxReportUrl: config.jmw_reports + config.reportBase + "app-report/equity/tax",
    taxYearDropDown: config.jmw_reports + config.reportBase + "app-report/common/financial-year",
    postionSquareOff: config.jmw_reports + config.eqedel + "trade/position/sqroff/v2/",
    dpTransactionHistory: config.jmw_reports + config.reportBase + "app-report/dp/transaction",
    dpIds: config.jmw_reports + config.reportBase + "app-report/dp/id",
    dpTransactionSubmit: config.jmw_reports + config.reportBase + "app-report/dp/submit",
    dpURL: config.jmw_reports + config.reportBase + "app-report/dp",
    rootUrl: config.rootUrl,
    margin: config.jmw_reports + config.reportBase + "app-report",
    contract: config.jmw_reports +
        config.reportBase +
        "app-report/contract/statementreport",
    contractNote: config.jmw_reports + config.reportBase + "app-report/contract/",
    transaction: config.jmw_reports + config.reportBase + "app-report/transaction",
    subscription: config.jmw_reports + config.reportBase + "app-report/subscription/fees",
    ledger: config.jmw_reports + config.reportBase + "app-report/equity/ledger/",
    ledgerComm: config.jmw_reports + config.reportBase + "app-report/comm/ledger/",
    marketMapAcc: config.jmw_reports + config.reportBase + "app-report/market/map",
    alertsOveriew: config.jmw_reports +
        config.reportBase +
        "app-report/login/dashboard/alerts",
    commonCommodity: config.jmw_reports + config.reportBase + "app-report/comm/statement",
    familyDetails: config.jmw_reports + config.reportBase + "app-report/family/details",
    consolidatedDetails: config.jmw_reports + config.reportBase + "app-report/family/holding",
    familyTagging: config.jmw_reports + config.reportBase + "app-report/family",
    clearTax: config.jmw + config.jmw_content + "auth/generate/auth-code",
};
var urlConfig = __assign(__assign({}, configURL), { jwttokenfornesttraderUrl: config.web_mw + "Account/jwttokenfornesttrader" });
export default urlConfig;
